export enum ValidationErrorType {
  AtLeastOneRequiredFromArray = 'atLeastOneRequiredFromArray'
}
